import { defineMessages } from 'react-intl';

export const ageGroupMessages = defineMessages({
  adults: {
    id: 'patientList.adults',
    defaultMessage: 'Adults',
  },
  children: {
    id: 'patientList.children',
    defaultMessage: 'Children',
  },
});
